export default "__VITE_ASSET__CfeVoZK6__"